<template>
  <GtcModal
    :open="open"
    :title="t('modals.common.goDeposit.title')"
    :confirm-loading="confirmLoading"
    width="367px"
    :ok-text="t('modals.common.goDeposit.button.confirm')"
    :cancel-text="t('modals.common.goDeposit.button.cancel')"
    @ok="handleOk"
    @cancel="$emit('cancel')"
  >
    <div class="w-full my-6 gap-4 ink-16 text-ink-950 font-medium">
      <span>{{ t('modals.common.goDeposit.message') }}</span>
    </div>
  </GtcModal>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import GtcModal from '@/components/gtc-modal/GtcModal.vue'

interface Props {
  open: boolean
  loading?: boolean
}

const props = defineProps<Props>()
const emit = defineEmits<{
  cancel: []
  confirm: [data: any]
}>()

const { t } = useI18n()
const submitting = ref(false)
const confirmLoading = computed(() => !!props.loading || submitting.value)

const handleOk = () => {
  if (submitting.value) return
  submitting.value = true
  emit('confirm', {})
}

// 父级 loading 结束时，若未关闭弹窗，释放本地 submitting 以允许重试
watch(
  () => props.loading,
  (val) => {
    if (!val) submitting.value = false
  },
)
</script>
